import { render } from "./DigitalID.vue?vue&type=template&id=958c6912&scoped=true"
import script from "./DigitalID.vue?vue&type=script&lang=js"
export * from "./DigitalID.vue?vue&type=script&lang=js"

import "./DigitalID.vue?vue&type=style&index=0&id=958c6912&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-958c6912"]])

export default __exports__